import Facade from '@/Facade'
import GameSignals from '@/signals/GameSignals'
import { BaseState } from '@/stateMachine/BaseState'
import { GameStatesEnum } from '@/states/GameStatesEnum'
import { WinningUtil } from '@/managers/winning/WinningUtil'

export class StopSpinState extends BaseState {
    public begin() {
        GameSignals.allReelsStopped.connect(this.end)
        GameSignals.stopButtonClicked.connect(this.onStopButtonClicked)

        this._model.bigWinLevel = WinningUtil.getBigWinLevel(this._model.spinData.base_win_currency, this._model.currentBaseBet)
        GameSignals.stopSpin.emit(this._model.spinData)

        if ((Facade as any).pendingImmediateStopRequested) {
            ;(Facade as any).pendingImmediateStopRequested = false
            GameSignals.immediatelyStop.emit()
        }
    }

    private onStopButtonClicked = () => {
        ;(Facade as any).pendingImmediateStopRequested = false

        GameSignals.immediatelyStop.emit()
    }

    public end = () => {
        this._model.spinState.isWinSkipped = false
        this._stateMachine.setState(GameStatesEnum.FINAL_STATE)
    }

    public cleanUp() {
        GameSignals.allReelsStopped.disconnect(this.end)
        GameSignals.stopButtonClicked.disconnect(this.onStopButtonClicked)
    }
}
